import {useState, useEffect} from "react";
import axios from "axios";
import {ItemContainerStyled, ImgContainerStyled, ItemEnglishTitleStyled, PriceContainerStyled, ItemButtonsContainerStyled, ItemButtonStyled, PopTextStyled, PopTextCloseStyled, ClosePopUpStyled, ClosePopButtonStyled, ItemTagsStyled, ItemDetailsWrapperStyled} from "./generalStyles";
import { faMagnifyingGlass, faXmark, faGrip, faPlus, faPenToSquare, faEyeSlash, faArrowsToEye, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import {Grid, Button, Drawer} from "@mui/material"
import {ThemeProvider} from "@mui/material/styles";
import { handleToolTip, handleHideItem, handleDeleteItem } from "../functions/generalFunctions";
import EditFrom from "./editForms/EditForm";
import DisplayMsg from "../DisplayMsg";
import { useNavigate, useLocation } from "react-router-dom";


function SearchDashboard({url, restaurantName, triggerToolTip, setTriggerToolTip, activeDashboard}) {

    {/* ALL CONSTANSTS AND HOOKS GO HERE */}
    const [searchQuery, setSearchQuery] = useState("");
    const [grabbedItems, setGrabbedItems] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const [item, setItem] = useState({});
    const [removeQuery, setRemoveQuery] = useState(false);
    const [popUpOpen, setPopUpOpen] = useState(false);
    const [itemDelete, setItemDelete] = useState("");
    const [itemID, setItemID] = useState("");
    const [openEditDrawer, setOpenEditDrawer] = useState(false);
    const [popUpMsg, setPopUpMsg] = useState({
        triggerMsg: false,
        msgToDisplay: "",
    });

    {/* ALL FUNCTIONS GO HERE */}
    //function that changes the searchQuery state as we search for the item
    function handleSearchQuery(event) {
        setSearchQuery(event.target.value);        
    }

    //grabs the items from the database //addd this function to general functions later
    async function handleSearchForm() {
        console.log(url);
        if(searchQuery != "") {
            console.log("i am here")
            try {
                const {data} = await axios.get(`${url}?search=${searchQuery}`, {
                    withCredentials: true,
                })
                if(data.items.length == 0) {
                    setPopUpMsg({
                        triggerMsg: true,
                        msgToDisplay: "Item not found!"
                    })
                }
                else {
                    setGrabbedItems(data.items);
                }
            } catch (error) {
                console.log(error.response.data.msg); //put it in a pop up later
            } 
           
        }
        else {
            // console.log(data.items);
            return;
        }
     
    }

    //function handle closeQueryButton {
    function handleCloseQueryButton() {
        /* delete the list of the searched items */
        setSearchQuery("");
        setGrabbedItems([]);
        setRemoveQuery(false);
    }
    
    {/* THE FUNCTIONS BELOW SHOULD BE UNIVERSAL */}
    //this function will trigger a pop up edit form to edit the chosen item
    function handleEditItem(_id) {
        //trigger drawer
        setOpenEditDrawer(true);
        //from the grabbedItems array add the chosen item.
        setItem(grabbedItems.find((item) => item._id === _id))
    }

  

    //function to trigger the pop up screen of the corresponding item (for deleting the item)
    function handleDeletePopUp(_id, itemName) {
        setPopUpOpen(true);
        setItemDelete(itemName);
        setItemID(_id);
    }

    async function handleDeleteButton() {
        //function to call api and delete item
        var from;

        try {
            const server_response = await handleDeleteItem(itemID, restaurantName);
    
            //once we get a confirmation that we deleted the item then close this pop up
            console.log("the item we deleted is: ", server_response);


            setPopUpMsg({
                triggerMsg: true,
                msgToDisplay: server_response,
            })

            //close the pop up and show message that we deleted the itme
            handleClosePopUp();
        } catch (error) {
            alert("session timed out, please login again!");
            from = location.state?.pathname || "/restaurants/menus/admin/login";
            navigate(from, {replace: true});
        }
    }

    async function handleHideItemButton(name_en, restaurantName, _id, hide, grabbedItems) {
        var from;
        try {

            var server_response = await handleHideItem(restaurantName, _id, hide, grabbedItems)
            var hideFlag = ""
            if(hide) {
                hideFlag = "hidden";
            } else {
                hideFlag = "unhidden"
            }
            server_response = `${name_en} has been successfully ${hideFlag}`;
            setPopUpMsg({
                triggerMsg: true,
                msgToDisplay: server_response
            })

        } catch (error) {
            alert("session timed out, please login again!");
            from = location.state?.pathname || "/restaurants/menus/admin/login";
            navigate(from, {replace: true});
        }
    }
    
    //this function closes the pop up screen if we dont delete (Related to upper function)
    function handleClosePopUp() {
        setPopUpOpen(false);
    }

    //add to the snack bar component that we will create
    //add the snackbar component on its own later on
    // function handleSnackBar() {
    //     setOpenSnackBar(false);
    // }

    return (
        <>
            <DisplayMsg popUpMsg = {popUpMsg} setPopUpMsg = {setPopUpMsg} />
            {/* THIS IS THE CLOSE BUTTON  */}
            {popUpOpen && <ClosePopUpStyled>
                    Are you sure you want to delete {itemDelete}
                        <Button
                            variant = "contained"
                            color = "primary"
                            onClick = {handleDeleteButton}
                        >
                            YES
                        </Button>
                    <ClosePopButtonStyled 
                        onClick = {handleClosePopUp}
                        onMouseEnter={() => handleToolTip(true, "close", setTriggerToolTip)}
                        onMouseLeave={() => handleToolTip(false, "close", setTriggerToolTip)}
                    >
                        <FontAwesomeIcon icon = {faXmark} style = {{fontSize: "20px", padding: "0"}}>
                        </FontAwesomeIcon>
                    </ClosePopButtonStyled>
            </ClosePopUpStyled>}
            <SearchBoxWrapperStyled>
                <SearchBoxContainerStyled>
                    <SearchTextFieldStyled placeholder = "Seach for item..."  onChange = {handleSearchQuery} value = {searchQuery}/>
                    { searchQuery && <CloseSearchContainerStyled onClick = {handleCloseQueryButton}>
                        <FontAwesomeIcon icon  = {faXmark} style = {{fontSize: "20px", paddingRight: "0px", color: "grey"}}/>
                    </CloseSearchContainerStyled>}
                </SearchBoxContainerStyled>
                <SearchButtonStyled onClick = {handleSearchForm}>
                    <FontAwesomeIcon icon = {faMagnifyingGlass} style = {{fontSize: "20px", paddingRight: "0px"}} />
                </SearchButtonStyled>
            </SearchBoxWrapperStyled>
            <GridContainerStyled>
                    {/* THIS IS WHERE WE TRIGGER THE EDIT FORM ON THE SIDE */}
                    <Drawer open = {openEditDrawer} anchor = "right" onClose = {() => setOpenEditDrawer(false)} style = {{width: "400px"}}>
                        <EditFrom restaurantName = {restaurantName} item = {item} activeDashboard = {activeDashboard}/>
                    </Drawer>
                    {/* THIS IS THE GRID THAT DISPLAYS THE ITEMS IN THE SEARCH RESULT */}
                    <Grid container spacing = {2}>
                        {grabbedItems.length !=0 && grabbedItems.map(({_id,name_en, category, branches , image, hide, price }) => {
                            return (
                                <Grid item xs = {4}>
                                    <ItemContainerStyled>
                                        <ItemButtonsContainerStyled>
                                            <ItemButtonStyled
                                                onMouseEnter = {() => handleToolTip(true, "hide", setTriggerToolTip)}
                                                onMouseLeave = {() => handleToolTip(false, "hide", setTriggerToolTip)}
                                                onClick = {() => handleHideItemButton(name_en, restaurantName, _id, !hide, grabbedItems)}
                                            >
                                                {triggerToolTip.hideTool && <PopTextStyled className="animate__animated animate__fadeInUp animate__faster">hide</PopTextStyled>}
                                                <FontAwesomeIcon icon = {faEyeSlash} style = {{fontSize: "20px", padding: "0", color: hide? "red" : "#585858"}}/>
                                            </ItemButtonStyled>
                                            <ItemButtonStyled
                                                onMouseEnter = {() => handleToolTip(true, "edit", setTriggerToolTip)}
                                                onMouseLeave = {() => handleToolTip(false, "edit", setTriggerToolTip)}
                                                onClick = {() => handleEditItem(_id)}
                                            >
                                                {triggerToolTip.editTool && <PopTextStyled className="animate__animated animate__fadeInUp animate__faster">edit</PopTextStyled>}
                                                <FontAwesomeIcon icon = {faPenToSquare} style = {{fontSize: "20px", padding: "0"}}/>
                                            </ItemButtonStyled>
                                            <ItemButtonStyled 
                                                onClick = {() => handleDeletePopUp(_id, name_en)}
                                                onMouseEnter = {() => handleToolTip(true, "delete", setTriggerToolTip)}
                                                onMouseLeave = {() => handleToolTip(false, "delete", setTriggerToolTip)}
                                            >
                                                {triggerToolTip.deleteTool && <PopTextStyled className = "animate__animated animate__fadeInUp animate__faster" >delete</PopTextStyled>}
                                                <FontAwesomeIcon icon = {faTrashCan}  style = {{fontSize: "20px", padding: "0px"}}/>
                                            </ItemButtonStyled>
                                        </ItemButtonsContainerStyled>
                                        <ImgContainerStyled>
                                            <img src = {image} alt = {name_en}/>
                                        </ImgContainerStyled>
                                        <ItemDetailsWrapperStyled>
                                            <ItemEnglishTitleStyled>
                                                {name_en}
                                                <PriceContainerStyled>
                                                    {price}
                                                    <span>QR</span>
                                                </PriceContainerStyled>
                                            </ItemEnglishTitleStyled>
                                            {/* UNHIDE WHEN WORKING ON WCS -- IMPORTANT -- FIX FOR LE BLEU */}
                                            {/* <ItemTagsStyled>
                                               {branches[0].name} - {category}
                                            </ItemTagsStyled> */}
                                        </ItemDetailsWrapperStyled>
                                    </ItemContainerStyled>
                                </Grid>
                            )
                        })}
                    </Grid>
                </GridContainerStyled>
        </>
    )
}


const SearchBoxWrapperStyled = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    
`
const SearchBoxContainerStyled = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 50px;
    border: 2px solid rgba(128, 128, 128, 0.4);
    border-right-width: 0;
    box-sizing: border-box;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    overflow: hidden; //ensures content stays within the border
    cursor: pointer;
    padding: 20px;
    gap: 10px;
    transition: all 300ms;

    //add react conditional activate later when u click on it to search to change borde to
    // border: 2px solid rgba(128 ,128, 128, 1);
`

const SearchButtonStyled = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    border: 2px solid grey;
    border-left-width: 0px;
    border-left: 2px solid black;
    opacity: 0.4;
    transition: 300ms all;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }

`

const SearchTextFieldStyled = styled.input`
    position: relative;
    outline: 0;
    border: 0;
    width: 100%;
`

const CloseSearchContainerStyled = styled.div`
    position: relative;
    margin-left: auto;
   
`

const GridContainerStyled = styled.div`
    position: relative;
    margin-top: 50px;
`

export default SearchDashboard;